<template>
  <!--
      作者：kmdshop
      时间：2020-06-01
      描述：插件中心-回访-添加
    -->
    <el-dialog
    title="添加设备"
    :visible.sync="dialogVisible"
    @close="dialogFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="50%"
  >

  <div class="product-add pb50">

    <el-form size="small" :model="form" ref="form" :rules="rules" label-width="100px">
      <div class="common-form">添加设备所属</div>

  
      

      <el-form-item label="选择服务商" v-if="dtype == 2"> 
        <el-row>
          <el-button @click="addClickService" v-if="!open_choose_service" icon="el-icon-plus">选择服务商</el-button>
          <div v-if="form.service_id!=''" class="img">
            <img :src="service_info.avatarUrl" width="100" height="100" />
            <div>名称：{{ service_info.name }}</div>
          </div>
        </el-row>
      </el-form-item>


      <el-form-item label="选择设备"> 
        <el-row>
          <el-button @click="addClickEquip" icon="el-icon-plus">选择设备</el-button>
          <div v-if="form.equip_id!=''" class="img">
            <div>名称：{{ equip_info.name }}</div>
          </div>
        </el-row>
      </el-form-item>


      <el-form-item label="设置比例" prop="rate">
        <el-input v-model="form.rate" placeholder="设置比例" class="max-w460"></el-input>
      </el-form-item>

      <!-- <el-form-item label="状态" prop="status">
      <div >
          <el-radio-group v-model="form.status">
            <el-radio  :label="1" >启用</el-radio>
            <el-radio  :label="0" >停用</el-radio>
          </el-radio-group>
      </div>
      </el-form-item>
       -->

    
      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
        <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>
  </div>
  <Filiale :is_open="open_add_filiale" :excludeIds="excludeIdsFiliale" :multi="multi" @close="closeDialogFunc"></Filiale>
  <Service :is_open="open_add_serivce" :excludeIds="excludeIdsService" :multi="multi" @close="closeDialogFuncService"></Service>
  <Equip :is_open="open_add_equip" :excludeIds="excludeIdsEquip" :multi="multi" @close="closeDialogFuncEquip"></Equip>
</el-dialog>
  
</template>

<script>
import EquipApi from '@/api/equip.js';
import Getpoint from '@/components/map/Getpoint.vue';
import Filiale from '@/components/fs/filiale.vue';
import Service from '@/components/fs/service.vue';
import Equip from '@/components/fs/equip.vue';
export default {
  components: {
    Getpoint,
    Filiale,
    Service,
    Equip
  },
  data() {
    return {

      /*form表单数据*/
      form: {
        name: '',
        equip_id:"",
        rate:0,
        service_id:0,
        filiale_id:0,
        status:1,
        type:1,
      },
      loading: false,
      /*验证规则*/
      rules: {

      },
      dialogVisible:false,

      filiale_id:0,
        filiale_info:{

        },
        equip_id:0,
        equip_info:{

        },

        open_add_filiale:false,
        multi:false,
     

        service_id:0,
       service_info:{

        },
        open_add_serivce:false,
        open_add_equip:false,


        open_choose_filiale:false,
        open_choose_service:false,


        excludeIdsFiliale:[],
        excludeIdsService:[],
        excludeIdsEquip:[],
    };
  },
  created() {
    this.dialogVisible = this.open_add;
    if(this.service_id_t){
            this.open_choose_service = true;      
        }
        this.getServiceUserById()

  },
  props: ["open_add",'dtype','filiale_id_t','service_id_t'],
  methods: {
    getServiceUserById(){
      var self = this;
      EquipApi.getServiceUserById({
        service_id:self.service_id_t
      }, true)
            .then(data => {
              if(data.data.service_id){
                  self.open_choose_service= true
                  self.form.service_id =    data.data.service_id;   
                  self.service_info = data.data
              }
    
      });
    },
    getFileUserById(){
      var self = this;
      EquipApi.getFileUserById({
        filiale_id:self.filiale_id_t
      }, true)
            .then(data => {
              if(data.data.filiale_id){
                  self.open_choose_filiale = true
                  self.form.filiale_id =    data.data.filiale_id;   
                  self.filiale_info = data.data
              }
    
      });
    },
    /*打开弹出层*/
    addClickService() {
        this.open_add_serivce = true;
      },

      /*关闭获取用户弹窗*/
      closeDialogFuncService(e) {
        if (e.type != 'error') {
          this.service_info = e.params;
          this.form.service_id = e.params.service_id;
        }
        this.open_add_serivce = false;
      },
      addClickEquip() {
        this.open_add_equip = true;
        //获取设备是否被自己选择
        var self = this;
       
      EquipApi.getEquipBySelf({
        filiale_id:self.filiale_id_t,
        service_id:self.service_id_t,
        type:self.form.type,
      }, true)
            .then(data => {
              self.excludeIdsEquip = data.data
      });
      },

      closeDialogFuncEquip(e) {
        if (e.type != 'error') {
          this.equip_info = e.params;
          this.form.equip_id = e.params.equip_id;
        }
        this.open_add_equip = false;
      },



    /*打开弹出层*/
  addClick() {
        this.open_add_filiale = true;
      },

      /*关闭获取用户弹窗*/
      closeDialogFunc(e) {
        if (e.type != 'error') {
          this.filiale_info = e.params;
          this.form.filiale_id = e.params.filiale_id;
        }
        this.open_add_filiale = false;
      },



     /*关闭弹窗*/
     dialogFormVisible(result) {
      this.$emit("close", { openDialog: false,"type":result });
    },
    cancelFunc(){//取消
      this.dialogFormVisible("error")
    },

    /*选择的地址*/
    choseFunc(e){
        this.form.coordinate=e.location.lat+','+e.location.lng;
        this.form.address=e.address;

      },
       /*获取经纬度*/
       getMapdataFunc(e) {
        this.form.coordinate = e.data[0].toFixed(6) + ',' + e.data[1].toFixed(6);
      },
    onSubmit() {
      let self = this;
      let form = self.form;
      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          EquipApi.bindFs(form, true)
            .then(data => {
              self.loading = false;
              self.$message({
                message: data.msg,
                type: 'success'
              });
              self.dialogFormVisible("error")
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    },

    /*取消添加，返回任务列表*/
    cancelFunc() {
      this.$emit("close", { openDialog: false,"type":"" });
    },
  }
};
</script>

<style>
.edit_container {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.ql-editor {
  height: 400px;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/equip/equip/belong/add.vue